import { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';

// 사용자 언어 설정 가져오기 (UserContext 사용)
export function useLanguage() {
  const { userInfo } = useContext(UserContext);
  
  if (userInfo && userInfo.preferred_language) {
    return userInfo.preferred_language;
  }
  
  // 기본값은 한국어
  return 'ko';
}

// 기존 getLang 함수와 호환되는 함수 (UserContext 사용)
export function getLang() {
  // UserContext를 직접 사용할 수 없는 경우를 위한 fallback
  const lang = (navigator.language || navigator.userLanguage || '').toLowerCase();
  if (lang.startsWith('ko')) return 'ko';
  if (lang.startsWith('fr')) return 'fr';
  return 'en';
}

// 언어 설정 유효성 검사
export function isValidLanguage(language) {
  return ['ko', 'en', 'fr'].includes(language);
}

// 언어 표시명 가져오기
export function getLanguageDisplayName(language) {
  const languageNames = {
    ko: '한국어',
    en: 'English',
    fr: 'Français'
  };
  return languageNames[language] || language;
}

// 언어 옵션 목록
export const LANGUAGE_OPTIONS = [
  { value: 'ko', label: '한국어' },
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' }
]; 